export const removeCommaFromNumber = (input: string | null): number => {
  if (!input) return 0;
  const numberWithCommasRemoved = input.replace(/,/g, "");
  return parseInt(numberWithCommasRemoved);
};
